export default {
  showFlashMessage(context, message) {
    context.commit('showFlashMessage', message)
    setTimeout(() => {
      context.commit('hideFlashMessage')
    }, 1800)
  },

  hideFlashMessage(context) {
    context.commit('hideFlashMessage')
  },

  toggleCart(context) {
    context.commit('toggleCart')
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js